import { connect } from 'react-redux';
import { compose } from 'redux';
import withPGTranslation from '../../config/withPGTranslation';
import Registration from './registration';
import {
  logIn,
  register,
  clearError,
  authSocial,
  displayRegister,
  changeScreen,
  navigationPop,
  authClearPendingAction,
  authErrorActionCreator,
  gdprSwitcherValueChanged,
  shouldShowGDPRConsent,
  updateCurrentScreen,
  registerByPhone,
  logInByPhone
} from '../../actions/auth';
import { loadHomePage } from '../../actions/home_page';
import { clearAffiliatePromoPopup } from '../../actions/affiliate_promo_popup';
import { getUserMatchUpBonusInfo } from '../../config/util';
import { withCurrentPath } from '../routes/hoc/with_current_path';
import { withRouter } from '../routes/hoc/with_router';

const mapStateToProps = ({ auth, user: { user }, application }) => ({
  ...auth,
  userShowMatchUpBonusInfo: user && user.showMatchUpBonusInfo,
  inEu: user?.inEu ?? application.dynamicConfig?.inEu,
  smsSettings: application.dynamicConfig?.uiSettings?.smsSettings,
  matchUpBonusInfo: getUserMatchUpBonusInfo({ bonusInfos: user && user.bonusInfos || application && application.anonymousUser && application.anonymousUser.bonusInfos }) ?? application.dynamicConfig?.matchUpBonusInfo,
  googleConfig: application.googleConfig,
  signUpFlow: application.dynamicConfig?.signUpFlow
});

export default connect(
  mapStateToProps,
  {
    logIn,
    logInByPhone,
    register,
    registerByPhone,
    clearError,
    authSocial,
    displayRegister,
    changeScreen,
    navigationPop,
    loadHomePage,
    clearAffiliatePromoPopup,
    authClearPendingAction,
    authErrorActionCreator,
    gdprSwitcherValueChanged,
    shouldShowGDPRConsent,
    updateCurrentScreen
  }
)(compose(withPGTranslation, withCurrentPath, withRouter)(Registration));
